import { Component, OnInit } from '@angular/core';
import { GetDataService } from '../../services/getdata.service';
import { ComponentType } from '../../enums/enum.type';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  fromDashboard = false;
  constructor(private getDataService:GetDataService) {
    this.getDataService.componentType.subscribe(response=>{
      if(response == ComponentType.summaryDashboard) this.fromDashboard = true;
      else this.fromDashboard = false;
    })
   }

  ngOnInit(): void {
  }

}
